export default __webpack_public_path__ + "5da64f459c8ae4fb4602b22cc71f5ff6.png";